import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheck, faMoonStars, faSunBright } from '@fortawesome/pro-duotone-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { THEME_MODES, ThemePreset } from '../theme-presets';

/** One selectable theme: its light and dark scenes drawn as a single split tile. */
@Component({
  selector: 'andor-theme-preset-tile',
  standalone: true,
  imports: [TranslatePipe, FaIconComponent],
  templateUrl: './theme-preset-tile.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './theme-preset-tile.scss',
})
export class ThemePresetTile {
  readonly preset = input.required<ThemePreset>();
  readonly selected = input(false);
  readonly picked = output<void>();

  protected readonly modes = THEME_MODES;
  protected readonly faCheck = faCheck;
  protected readonly faSunBright = faSunBright;
  protected readonly faMoonStars = faMoonStars;
}
